<template>
  <div>
    <b-modal
      id="addSMSModal"
      modal-class="modal-doom-yoga"
      centered
      hide-footer
    >
      <template #modal-title> Add New SMS </template>

      <b-form @submit.prevent="onSubmit">
        <b-row class="mt-3">
          <b-col md="12">
            <b-form-group
              label="SMS Title"
              label-for="sms_title"
              :sms_title="sms_title"
              label-class="form-label-doomyoga"
            >
              <b-form-input
                id="sms_title"
                v-model="sms_title"
                :sms_title="sms_title"
                class="form-control-doomyoga"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="">
          <b-col md="12">
            <b-form-group
              label="SMS Context"
              label-for="sms_context"
              :sms_context="sms_context"
              label-class="form-label-doomyoga"
            >
              <b-form-textarea
                id="sms_context"
                v-model="sms_context"
                :sms_context="sms_context"
                class="form-control-doomyoga"
                rows="3"
                required
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group
              class="form-group-vselect-doomyoga"
              id="smsSendToFormGroup"
              label="Send to"
              label-for="send_to"
              :send_to="send_to"
              label-class="form-label-doomyoga"
            >
              <p class="error_validation_message_p" v-if="invalid_send_to">
                Please select send to
              </p>
              <v-select
                :options="send_to_options"
                name="send_to"
                title="send_to"
                v-model="send_to"
                :reduce="(item) => item.code"
                required
              ></v-select
            ></b-form-group>
          </b-col>
        </b-row>
        <b-row class="justify-content-center w-100 mt-5">
          <b-col lg="4" md="6" class="text-center">
            <b-button
              type="submit"
              variant="doomyoga-primary"
              class="w-100 btn-bumblebee btn-doomyoga btn-doomyoga-submit"
              v-if="!is_loading"
            >
              Save
            </b-button>
            <b-button
              type="submit"
              disabled
              variant="doomyoga-primary"
              class="w-100 btn-bumblebee btn-doomyoga btn-doomyoga-submit"
              v-else
            >
              <b-spinner
                small
                label="Small Spinner"
                variant="light"
              ></b-spinner>
              Loading
            </b-button>
          </b-col>

          <b-col lg="4" md="6" class="text-center">
            <b-button
              type="button"
              variant="doomyoga-danger-outline"
              class="w-100 btn-bumblebee btn-doomyoga btn-doomyoga-submit"
              @click="closeModal('addSMSModal')"
            >
              Cancel
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
    <SelectEventModal />
  </div>
</template>
<script>
import $ from "jquery";
import axios from "axios";
import SelectEventModal from "./SelectEventModal.vue";

export default {
  name: "AddSmsModal",
  components: { SelectEventModal },
  props: ["user_id"],
  data() {
    return {
      is_loading: false,
      sms_title: null,
      sms_context: null,
      send_to: null,
      invalid_send_to: false,
      send_to_options: [
        { label: "Select event", code: "event" },
        { label: "Members only", code: "members" },
        { label: "All users", code: "all_users" },
      ],
    };
  },
  mounted() {
    // console.log(this.$parent)
  },
  watch: {
    send_to(newval, oldval) {
      console.log(newval, oldval);
      if (newval == "event") {
        this.$root.$emit("bv::show::modal", "select-event-modal");
      }
    },
  },
  methods: {
    closeModal(id) {
      this.$bvModal.hide(id);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/SMS/AddSmsModal.vue